import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type WorkflowRunAbandonmentFailedAction = {
	type: 'WORKFLOW_RUN_ABANDONMENT_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): WorkflowRunAbandonmentFailedAction => ({
	type: 'WORKFLOW_RUN_ABANDONMENT_FAILED',
	payload,
});
